import '../assets/styles/Footer.css'

export default function Footer() {
    return (
        <div className="footer w-100 d-flex align-items-center justify-content-center">
            <div className='footer-icon rounded-circle bg-dark text-light border-light border border-3 d-flex align-items-center justify-content-center me-3'>
            <i class="bi bi-envelope"></i>
            </div>
            <div className='footer-icon rounded-circle bg-dark text-light border-light border border-3 d-flex align-items-center justify-content-center'>
                <i class="bi bi-instagram"></i>
            </div>
            <div className='footer-icon rounded-circle bg-dark text-light border-light border border-3 d-flex align-items-center justify-content-center ms-3'>
                <i class="bi bi-discord"></i>
            </div>
        </div>
    )
}